import { signalStore } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';

import { Interrelation } from '../models/interrelation.model';
import { avecMéthodesInterrelations } from './interrelation.methods';

export const InterrelationStore = signalStore(
  { providedIn: 'root' },
  withEntities<Interrelation>(),
  avecMéthodesInterrelations(),
);
